import React, { FC } from "react";
import { Link } from "react-router-dom";

interface Props {
  available: string[];
}

interface ConfigItem {
  id: string;
  order: number;
  title: string;
  icon: string;
  to: string;
  name: string;
  isDefault?: boolean;
}

const Products: FC<Props> = ({ available }) => {
  const configs: ConfigItem[] = [
    {
      id: "dashboard",
      isDefault: true,
      order: 1,
      title: "Painel",
      icon: "fas fa-columns",
      to: "/painel",
      name: "Painel",
    },
    {
      id: "analysis",
      isDefault: true,
      order: 10,
      title: "Análise de precatórios",
      icon: "fas fa-chart-bar",
      to: "/analise",
      name: "Análise",
    },
    {
      id: "crm",
      order: 2,
      title: "Negociações",
      icon: "far fa-handshake",
      to: "/negocios",
      name: "Negociação",
    },
    {
      id: "search",
      order: 3,
      title: "Buscar precatórios",
      icon: "fa fa-search",
      to: "/busca",
      name: "Busca",
    },
    {
      id: "api",
      order: 4,
      title: "Documentação da API",
      icon: "fas fa-plug",
      to: "/api",
      name: "API",
    },
  ];

  return (
    <div className="nb-products-container">
      <ul className="nb-products-list">
        {configs
          .sort((a, b) => a.order - b.order)
          .map(({ id, isDefault, icon, name, ...restProps }) => {
            return (
              (isDefault || available.includes(id)) && (
                <li key={id} className="nb-product-item">
                  <Link {...restProps}>
                    <i
                      className={`mr-icon-item-menu fa-lg fa-fw ${icon} nb-product`}
                    />
                    <span className="nb-product-name">{name}</span>
                  </Link>
                </li>
              )
            );
          })}
      </ul>
    </div>
  );
};

export default Products;
